import { MaxDate } from 'mbs-ui-shared@constants/c-sharp-constants';
import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';
import { RecurringSchedule } from 'mbs-ui-shared@models/ScheduleModel';
import {
  AgentVersionForNBFHybrid,
  AgentVersionForNBFHybridIgnore,
  WizardHelpersSettings
} from 'wizards/helpers/bases/base-for-steps-helper';
import { GlacierRestoreTiers } from 'wizards/models/base/base-models/plan-glacier-restor-tiers-model';
import { RestoresFormData } from 'wizards/models/base/base-restore-vm-types';

export type AllowSettings = { all: boolean; compression: boolean; encryption: boolean };

export class BaseForPlanHelper {
  public static isNBF = false;
  public static isNBFWithHybrid = false;
  public static FullRecurringSchedule: RecurringSchedule = null;
  public static BlockLevelRecurringSchedule: RecurringSchedule = null;
  public static ScheduleDiff: RecurringSchedule = null;
  public static ScheduleTLog: RecurringSchedule = null;
  public static isUnix = false;
  public static isNetBuild = false;
  public static restoreVMTypes = [
    PlanTypes.RestoreHyperV,
    PlanTypes.RestoreHyperVToCustom,
    PlanTypes.RestoreVMware,
    PlanTypes.RestoreVMwareToCustom
  ];

  static canHybridOnNbf(version: string): boolean {
    if (!version) return false;

    const versionNum = version ? +version.substring(0, 3) : 0;

    return versionNum >= AgentVersionForNBFHybrid && !AgentVersionForNBFHybridIgnore.includes(versionNum);
  }

  static updateSchedules(needUpdate: boolean, step): void {
    if (needUpdate) {
      this.FullRecurringSchedule = step.forceFull ? step.forceFull.FormSchedule : null;
      this.BlockLevelRecurringSchedule = step.blockLevel ? step.blockLevel.FormSchedule : null;
      this.ScheduleDiff = step.scheduleDiff ? step.scheduleDiff.FormSchedule : null;
      this.ScheduleTLog = step.scheduleTLog ? step.scheduleTLog.FormSchedule : null;
    }
  }

  static setDataFromRestore(newPlan, settings: WizardHelpersSettings, model: RestoresFormData, savePass = false, savePoint = false): void {
    if (settings.isNBF) {
      newPlan.RestorePoint = `CBB_Archive\\${model.backupToRestoreStep.selectedBunch}`;
      if (model.restorePointStep.resultPoint) {
        newPlan.RestorePoint += `\\${model.restorePointStep.resultPoint.restorePointId}`;
      }
    } else newPlan.RestorePoint = null;
    newPlan.RestoreSourcePrefix = model.computerToRestoreStep.computerName;
    newPlan.GlacierRestoreTier = GlacierRestoreTiers.Standard;
    newPlan.LimitRestore = !this.restoreVMTypes.includes(settings.planType);

    if (!newPlan.LimitRestore) {
      if (!savePass) delete newPlan.EncryptionPassword;
      if (!savePoint) newPlan.PointInTime = MaxDate;
      newPlan.GlacierRestoreTier = GlacierRestoreTiers.Expedited;
      newPlan.PerformRestoreSimulation = true;
    }

    if (settings.planType === PlanTypes.RestoreHyperV) {
      newPlan.Host = settings.compName;
      newPlan.RestoreToHost = settings.compName;
    }
  }
}
